import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/index-logo.png';
import _imports_1 from '../../assets/service.png';
const _withScopeId = n => (_pushScopeId("data-v-3b14b2fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "logo_top"
};
const _hoisted_2 = {
  class: "container flex_jcsb flex_aic"
};
const _hoisted_3 = {
  class: "left_area flex_aic"
};
const _hoisted_4 = {
  class: "search_capsule flex_aic hide_mobile"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search_divider"
}, "|", -1));
const _hoisted_6 = ["onKeyup"];
const _hoisted_7 = {
  class: "search_dropdown"
};
const _hoisted_8 = ["onMousedown"];
const _hoisted_9 = {
  class: "right_area flex_aic"
};
const _hoisted_10 = {
  class: "nav_menu flex_aic"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "76px"
  }
}, null, -1));
const _hoisted_12 = {
  class: "footer_wrap"
};
const _hoisted_13 = {
  class: "container"
};
const _hoisted_14 = {
  class: "footer_main flex_jcsb"
};
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"footer_left\" data-v-3b14b2fe><div class=\"footer_logo flex_aic\" data-v-3b14b2fe><span class=\"logo_main\" data-v-3b14b2fe>万象</span><span class=\"logo_sub\" data-v-3b14b2fe>租物</span></div><p class=\"footer_desc\" data-v-3b14b2fe> 深圳市趣易租网络科技有限公司旗下全品类信用免押租赁平台。国内第一家PaaS产品订阅即服务平台，让信用改变生活，让租赁更简单高效，让绿色生活触手可及。 </p><div class=\"footer_address\" data-v-3b14b2fe><p class=\"addr_item\" data-v-3b14b2fe><span class=\"addr_icon\" data-v-3b14b2fe>🏛️</span><span data-v-3b14b2fe>总部：广东省深圳市 · 成立于2015年</span></p><a href=\"https://www.amap.com/search?query=深圳红山6979商业中心\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"addr_map_link\" title=\"点击查看高德地图定位\" data-v-3b14b2fe><p class=\"addr_item hover_link\" data-v-3b14b2fe><span class=\"addr_icon\" data-v-3b14b2fe>🏪</span><span data-v-3b14b2fe>门店：深圳红山6979商业中心 📍</span></p></a></div></div>", 1);
const _hoisted_16 = {
  class: "footer_right flex_jcsb"
};
const _hoisted_17 = {
  class: "footer_col"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "col_title"
}, "产品分类", -1));
const _hoisted_19 = {
  class: "col_links"
};
const _hoisted_20 = {
  class: "footer_col"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "col_title"
}, "帮助支持", -1));
const _hoisted_22 = {
  class: "col_links"
};
const _hoisted_23 = {
  class: "footer_col"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "col_title"
}, "关于我们", -1));
const _hoisted_25 = {
  class: "col_links"
};
const _hoisted_26 = {
  class: "footer_bottom flex_jcsb flex_aic"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "copyright_text"
}, "© 2015-2026 深圳市趣易租网络科技有限公司 粤ICP备2021129882号-1", -1));
const _hoisted_28 = {
  class: "bottom_links flex_aic"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amap.com/search?query=深圳红山6979商业中心",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "map_link_btn",
  title: "在新窗口中查看地图定位"
}, "网站地图", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cschat.antcloud.com.cn/index.htm?tntInstId=BiB_Rw5m&scene=SCE01202417",
  class: "service"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
import { ref, reactive, computed, watch, onMounted as onMountedHeader, onUnmounted as onUnmountedHeader } from 'vue';
import { useStore } from 'vuex';
import { selectCateProduct } from '@/api/api';
import { useRouter, useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    store.dispatch('getHeaderList'); // 获取顶部导航
    store.dispatch('getPhoneNumber'); // 获取手机号码
    const navList = computed(() => {
      return store.state.navHeaderList;
    });
    const phoneList = computed(() => {
      return store.state.phoneNumberList;
    });
    const helpList = computed(() => {
      return store.state.articleCateList;
    });
    const navAd = computed(() => {
      return store.state.navAd;
    });
    const hotCodeShow = ref(false);
    const resultList = reactive({
      list: []
    });
    const searchCode = ref('');
    // 离开 /category 路由去到其他页面时清空搜索框
    watch(() => route.path, newPath => {
      if (newPath !== '/category') {
        searchCode.value = '';
        hotCodeShow.value = false;
      }
    });
    // 判断当前路由高亮
    const isCurrentRoute = path => {
      if (path === '/') {
        return route.path === '/';
      }
      return route.path.startsWith(path);
    };
    // 立即租赁
    const goRent = () => {
      router.push('/category');
    };
    // 选择热门联想词
    const selectHotProduct = name => {
      searchCode.value = name;
      goCategory();
    };
    const goCategory = () => {
      if (timer) {
        clearTimeout(timer);
      }
      hotCodeShow.value = false;
      const keyword = searchCode.value.trim();
      if (!keyword) return;
      router.push({
        path: '/category',
        query: {
          code: keyword
        }
      });
    };
    const onFocusout = () => {
      setTimeout(() => {
        hotCodeShow.value = false;
      }, 310);
    };
    let timer;
    // 防抖搜索
    const onInput = () => {
      timer && clearTimeout(timer);
      timer = setTimeout(async () => {
        if (!searchCode.value.trim()) {
          hotCodeShow.value = false;
          return;
        }
        const {
          data
        } = await selectCateProduct({
          tag: 'specialty',
          categoryid: '',
          typeid: '',
          page: '',
          pagenum: '',
          sortby: '',
          city: '',
          ds: 4,
          search_name: searchCode.value
        });
        if (data && data.resultTag === 'y') {
          resultList.list = data.productlist.page_result.slice(0, 7);
          hotCodeShow.value = true;
        }
      }, 300);
    };
    // 滚动监听
    const isScrolled = ref(false);
    const handleScroll = () => {
      isScrolled.value = window.scrollY > 20;
    };
    onMountedHeader(() => {
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
      handleScroll();
    });
    onUnmountedHeader(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_Search = _resolveComponent("Search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_link = _resolveComponent("router-link");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["header_box", {
          'is_scrolled': isScrolled.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "logo_img",
        src: _imports_0,
        alt: "万象租物",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/'))
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
        class: "search_icon",
        size: 18,
        color: "#2F4FFA",
        onClick: goCategory
      }, {
        default: _withCtx(() => [_createVNode(_component_Search)]),
        _: 1
      }), _hoisted_5, _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "search_input",
        placeholder: "搜索iPhone、MacBook、相机、游戏机...",
        onInput: onInput,
        onFocusout: onFocusout,
        onKeyup: _withKeys(goCategory, ["enter"]),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchCode.value = $event)
      }, null, 40, _hoisted_6), [[_vModelText, searchCode.value]]), _withDirectives(_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultList.list, (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          href: "javascript:;",
          key: index,
          onMousedown: $event => selectHotProduct(item.product_name)
        }, _toDisplayString(item.product_name), 41, _hoisted_8);
      }), 128))], 512), [[_vShow, hotCodeShow.value]])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass(["nav_item", {
          active: isCurrentRoute('/')
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" 首页 ")]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/category",
        class: _normalizeClass(["nav_item", {
          active: isCurrentRoute('/category') || isCurrentRoute('/product-detail')
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" 全部产品 ")]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/set/about-us",
        class: _normalizeClass(["nav_item", {
          active: isCurrentRoute('/set/about-us')
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" 关于我们 ")]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/help-center",
        class: _normalizeClass(["nav_item", {
          active: isCurrentRoute('/help-center')
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" 帮助中心 ")]),
        _: 1
      }, 8, ["class"])]), _createElementVNode("button", {
        class: "rent_now_btn",
        onClick: goRent
      }, "立即租赁")])])])], 2), _hoisted_11, _createVNode(_component_router_view), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("3C数码租赁")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("相机镜头")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("游戏装备")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("户外装备")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("家居家电")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/category"
      }, {
        default: _withCtx(() => [_createTextVNode("智能硬件")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createVNode(_component_router_link, {
        to: "/help-center"
      }, {
        default: _withCtx(() => [_createTextVNode("租机流程")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/help-center"
      }, {
        default: _withCtx(() => [_createTextVNode("常见问题")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/help-center"
      }, {
        default: _withCtx(() => [_createTextVNode("租期说明")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/help-center"
      }, {
        default: _withCtx(() => [_createTextVNode("损坏赔偿")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/help-center"
      }, {
        default: _withCtx(() => [_createTextVNode("买断续租")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("公司介绍")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("发展历程")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("核心优势")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/merchant"
      }, {
        default: _withCtx(() => [_createTextVNode("招商入驻")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("隐私政策")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("用户协议")]),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("隐私政策")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/set/about-us"
      }, {
        default: _withCtx(() => [_createTextVNode("用户协议")]),
        _: 1
      }), _hoisted_29])])])]), _hoisted_30], 64);
    };
  }
});